import { Box, Checkbox, Grid, InputAdornment } from '@mui/material'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

export const ControleSection = () => {
    const { setValue, getValues } = useFormContext()
    const [disabled, setDisabled] = useState(() => {
        const entradaDiaSeguinte = getValues('entradaDiaSeguinte')
        return !entradaDiaSeguinte
    })

    return (
        <Box component="section" id="controle">
            <Grid container columns={12} spacing={1} columnSpacing={2}>
                <Grid item xs={12}>
                    <FormField
                        name="nomeSocial"
                        label="Nome social"
                        placeholder="Nome para o e-social"
                    />
                </Grid>
                <Grid item xs={5}>
                    <FormField
                        name="entradaDiaSeguinte"
                        label="Entrada no dia seguinte"
                        focused={!disabled}
                        disabled={disabled}
                        options={{
                            timePattern: ['h', 'm'],
                            time: true,
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className="-ml-4"
                                >
                                    <IconeAjuda>
                                        Se o funcionário faz uma jornada que
                                        começa em dia, tem uma pausa e volta a
                                        trabalhar no dia seguinte, você pode
                                        marcar essa opção e definir o horário de
                                        entrada. Assim, o horário de entrada
                                        (geralmente após a meia noite) será
                                        considerado como entrada na jornada
                                        correta.
                                    </IconeAjuda>
                                    <Checkbox
                                        checked={!disabled}
                                        title='Habilitar campo "Entrada no dia seguinte"'
                                        onChange={(_, checked) => {
                                            setDisabled(!checked)

                                            if (checked) {
                                                setValue(
                                                    'entradaDiaSeguinte',
                                                    '23:00',
                                                )
                                            } else {
                                                setValue(
                                                    'entradaDiaSeguinte',
                                                    null,
                                                )
                                            }
                                        }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={3.8}>
                    <FormField
                        label="Bônus de vale"
                        name="bonusValeAlimentacao"
                        type="number"
                        InputProps={{
                            endAdornment: (
                                <div className="inline-flex items-center">
                                    <span>%</span>
                                    <IconeAjuda>
                                        Esse é o bônus que vai ser aplicado
                                        sobre o valor do vale alimentação.
                                    </IconeAjuda>
                                </div>
                            ),
                        }}
                    />
                </Grid>
                <Grid
                    item
                    xs={3.2}
                    className="inline-flex items-center *:-mt-4"
                >
                    <FormFieldCheckbox
                        label="Recebe vale alimentação"
                        name="recebeValeAlimentacao"
                    />
                    <IconeAjuda>
                        Desmarque essa opção caso você não queira que o
                        funcionário seja incluído no relatório de vale
                        alimentação nem que o valor do vale alimentação seja
                        considerado na integração da folha de pagamento.
                    </IconeAjuda>
                </Grid>
            </Grid>
        </Box>
    )
}
